<template>
  <div :class="localClasses" @click="$emit('click')">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    props:['active', 'disabled'],
    data() {
      return{
        localState: this.state,
      }
    },
    computed:{
      localClasses(){
        let css = 'round-btn';
        if (this.$attrs.bordered !== undefined) { css += ' round-btn-bordered' }
        if (this.active) { css += ' active' }
        if (this.disabled) { css += ' disabled' }
        return css;
      }
    }
  }
</script>
